import { FestivalEventType } from '@api';
import { FestivalAnchor, VenueAnchor } from '@common';
import { faCalendar, faLocationDot } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Group, Stack, Text } from '@mantine/core';
import dayjs from 'dayjs';

type FestivalHoverCardPropsType = {
  festival: FestivalEventType;
};

export const FestivalHoverCard: React.FC<FestivalHoverCardPropsType> = ({
  festival,
}) => {
  return (
    <Stack align="center" gap={16}>
      <Stack align="center" gap={1}>
        <Text fw={700}>
          <FestivalAnchor festival={festival.festival} />
        </Text>
        <Group gap={2}>
          <FontAwesomeIcon icon={faLocationDot} size="sm" />
          <VenueAnchor venue={festival.venue} />
        </Group>
      </Stack>
      <Group gap={2}>
        <FontAwesomeIcon icon={faCalendar} size="sm" />
        <Text>
          {`${dayjs(festival.startDate).format('DD.MM.YYYY')} - ${dayjs(festival.endDate).format('DD.MM.YYYY')}`}
        </Text>
      </Group>
    </Stack>
  );
};
